import {useMutation} from 'react-query';
import {client} from './ApiClient';

const getStripePaymentForm = ({urls, session, domain, deviceCode, successUrl, cancelUrl}: { urls: any; session: string; domain: string; deviceCode: string; successUrl: string; cancelUrl: string }) => {
    const query = `successUrl=${encodeURIComponent(successUrl)}&cancelUrl=${encodeURIComponent(cancelUrl)}`
    return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/sessions/${session}/paymentform/stripe?${query}`);
}

export default function useStripePaymentForm() {
    // @ts-ignore
    return useMutation(getStripePaymentForm);
}
